/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IntegrationError } from "./IntegrationError";

/**
 * Service Error
 */
export class ServiceError extends IntegrationError {}

/**
 * Vault Error
 */
export class VaultError extends ServiceError {}
